import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class CheckWebpSupportService {
  private _webpSupported: boolean | null = null;

  private _checkWebpSupport(): void {
    const canvas = document.createElement('canvas');
    this._webpSupported = canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;

    const kTestImage = 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';

    const img = new Image();
    img.onload = () => {
      const result = img.width > 0 && img.height > 0;
      this._webpSupported = this._webpSupported && result;
    };
    img.onerror = () => {
      this._webpSupported = false;
      console.error('WebP image load error, WebP support set to false');
    };
    img.src = `data:image/webp;base64,${kTestImage}`;
  }

  isWebpSupported(): boolean {
    return this._webpSupported ?? false;
  }

  init(): void {
    // This method can be used to trigger the check if needed
    this._checkWebpSupport();
  }
}
